import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { ApiResponseModel, BasicApiResponseModel, PagingResponseModel } from '../shared/api-response.model';
import { ApiVisa } from '../shared/api-visa.model';
import { Observable } from 'rxjs';
import { postQueryMstAttributeChildLink } from '../../../../../models/aggregates/cp-commerce/index';
import { Pagination } from '../shared';

@Injectable({
  providedIn: 'root'
})
export class CpCommerceAttributeService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CPCOMMERCE_PREFIX + 'attributes';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CPCOMMERCE_PREFIX + 'attributes';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CPCOMMERCE_PREFIX + 'attributes';
    this.httpClient = http;
  }

  public attributePublic(
    pagination: Pagination,
    dtoObject: any,
    visa: ApiVisa
  ): Observable<PagingResponseModel<postQueryMstAttributeChildLink>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/' + Core2Config.PUBLIC_EP_SUFFIX + '/' + 'query?' + pagination.getQueryKeyValues();
    }
    const url = this.apiUrl ;
    return this.httpClient.post<PagingResponseModel<postQueryMstAttributeChildLink>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public attributePublicOrg(
    dtoObject: any,
    visa: ApiVisa
  ): Observable<PagingResponseModel<postQueryMstAttributeChildLink>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/' + Core2Config.PUBLIC_EP_SUFFIX;
    }
    const url = this.apiUrl ;
    return this.httpClient.post<PagingResponseModel<postQueryMstAttributeChildLink>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public attributeBackOffice(
    dtoObject: any,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    }
    const url = this.apiUrl ;
    return this.httpClient.post<BasicApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
